import { default as SingleAsset } from '../components/cards/singleAsset';
import { default as PromoOneImage } from '../components/cards/promoOneImage';
import { default as TaboolaOrganic } from '../components/cards/taboola-organic';
import { default as TaboolaSponsored } from '../components/cards/taboola-sponsored';
import { default as Ad } from '../components/cards/ad';

/**
 * Contains collections of CardWidgets
 * Use `getCardWidget()` instead of importing this directly.
 */
export const CARD_COLLECTION = {
	default: SingleAsset,
	single_image_story: SingleAsset,
	promo_1_image: PromoOneImage,
	'Taboola-Organic': TaboolaOrganic,
	'Taboola-Sponsored': TaboolaSponsored,
	Ad
};

/**
 * Will return the type property of the supplied cardData object, but...
 * If the type is 'framework-entity' and a uri  property is also present, the uri will be returned as the type.
 * @param {Object} cardData - An object with a type property that's a string.
 */
export function typeForCardData({ type, uri }={}) {
	return (type === 'framework-entity' && uri) && uri || type;
}

/**
 * Retrieves a CardWidget for the supplied cardData/type and collection.
 * @param {Object|String} cardData - Either an object with a .type string property or a string of the type.
 * @returns {Object} A CardWidget Object or null if the CardWidget cannot be found.
 */
export function getCardWidget(cardData) {
	if (!cardData) return null;
	if (typeof cardData === 'string') return CARD_COLLECTION[cardData];
	if (cardData.type) return CARD_COLLECTION[typeForCardData(cardData)];
	return null;
}

export function getCardType(cardData) {
	if (!cardData) return null;
	if (typeof cardData === 'string') return cardData;
	if (cardData.type) return typeForCardData(cardData);
	return null;
}



// WEBPACK FOOTER //
// ../node_modules/@cube/dcc-widget-v2/src/lib/collection.js